/*
 *******************************************************************************
 *
 *  Filename:   /redux/slices/formsites.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Calls redux reducer
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Monday, February 10, 2025 - 1:08 AM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2025/02/10  NJN Initial Build
 *
 *  Copyright (c) 2025 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { createSlice } from "@reduxjs/toolkit";
import { updateFieldReducer, updateTypedFieldReducer } from "@/redux/reducerHelpers";
import { daysAgoLocalMidnightIso, tomorrowLocalMidnightIso } from "@/utils/dateRange";

const INCOMING_CASES_START_DAYS_BACK = 4;

const initialState = {
  callid: 0,
  error: null,
  defaultToolPanel: "filter",
  order: "NAME ASC",
  search: "",
  caseIdSearch: "",
  nameSearch: "",
  patientStatus: "",
  providerFilter: 0,
  fCallID: 0,
  columnState: [],
  startDate: daysAgoLocalMidnightIso(INCOMING_CASES_START_DAYS_BACK),
  endDate: tomorrowLocalMidnightIso(),
  autoRefresh: false,
};

const intFields = ["formsiteid"];

export const sessionSlice = createSlice({
  name: "formsites",
  initialState,
  reducers: {
    updateFormSiteID: (state, action) => updateFieldReducer(state, action, "formsiteid"),
    updateSearch: (state, action) => updateFieldReducer(state, action, "search"),
    updateCaseIdSearch: (state, action) => updateFieldReducer(state, action, "caseIdSearch"),
    updateNameSearch: (state, action) => updateFieldReducer(state, action, "nameSearch"),
    updatePatientStatus: (state, action) => updateFieldReducer(state, action, "patientStatus"),
    updateProviderFilter: (state, action) => updateFieldReducer(state, action, "providerFilter"),
    updateFCallID: (state, action) => updateFieldReducer(state, action, "fCallID"),
    updateDefaultToolPanel: (state, action) => updateFieldReducer(state, action, "defaultToolPanel"),
    updateColumnState: (state, action) => updateFieldReducer(state, action, "columnState"),
    updateStartDate: (state, action) => updateTypedFieldReducer(state, action, "startDate", initialState),
    updateEndDate: (state, action) => updateTypedFieldReducer(state, action, "endDate", initialState),
    updateAutoRefresh: (state, action) => updateFieldReducer(state, action, "autoRefresh"),
    resetDateFilters: (state) => {
      state.startDate = daysAgoLocalMidnightIso(INCOMING_CASES_START_DAYS_BACK);
      state.endDate = tomorrowLocalMidnightIso();
      state.error = null;
    },
  },
});

export const {
  updateFormSiteID,
  updateSearch,
  updateCaseIdSearch,
  updateNameSearch,
  updatePatientStatus,
  updateProviderFilter,
  updateFCallID,
  updateDefaultToolPanel,
  updateColumnState,
  updateStartDate,
  updateEndDate,
  updateAutoRefresh,
  resetDateFilters,
} = sessionSlice.actions;

export default sessionSlice.reducer;
